const evt = (entity) => ({
    CREATED: `centreservice.${entity}.created`,
    UPDATED: `centreservice.${entity}.updated`,
    DELETED: `centreservice.${entity}.deleted`,
});

// SignalR entities: KEY -> backend event slug.
const SIGNALR_ENTITIES = {
    CENTRE: 'centre',
    PROPERTY: 'property',
    DOCUMENT: 'document',
    STAFF: 'staff',
    STAFF_ROLE: 'staffrole',
    STAFF_ROLE_INSTANCE: 'staffroleinstance',
    STAFF_TAG: 'stafftag',
    LICENCE: 'licence',
    LICENCE_HOURS: 'licencehours',
    LICENCE_STATUS: 'licencestatus',
    LICENCE_CLASS: 'licenceclass',
    LICENCE_SERVICE: 'licenceservice',
    REGION: 'region',
    AREA: 'area',
    ADDRESS: 'address',
    ROLE: 'role',
    TAG: 'tag',
    DOCUMENT_TYPE: 'documenttype',
    LEASE: 'lease',
    LEASE_DATE: 'leasedate',
    LEASE_NOTE: 'leasenote',
    LEASE_TYPE: 'leasetype',
    LESSOR: 'lessor',
    PROJECT: 'project',
    PROJECT_STATUS: 'projectstatus',
    PROJECT_TYPE: 'projecttype',
    ISSUE: 'issue',
    ISSUE_TYPE: 'issuetype',
    ROOM: 'room',
    ROOM_TYPE: 'roomtype',
    BUILDING_TYPE: 'buildingtype',
    PROPERTY_STATUS: 'propertystatus',
    CENTRE_MERCHANT: 'centremerchant',
    CENTRE_TAG: 'centretag',
    BRAND: 'brand',
    CENTRE_TYPE: 'centretype',
    CENTRE_STATUS: 'centrestatus',
    COST_CENTRE: 'costcentre',
};

// signalR.service auto-registers a hub handler for every string value here.
const SIGNALR = { CONNECTED: 'signalr.connected', DISCONNECTED: 'signalr.disconnected' };
for (const [name, entity] of Object.entries(SIGNALR_ENTITIES)) {
    const { CREATED, UPDATED, DELETED } = evt(entity);
    SIGNALR[`${name}_CREATED`] = CREATED;
    SIGNALR[`${name}_UPDATED`] = UPDATED;
    SIGNALR[`${name}_DELETED`] = DELETED;
}

const events = {
    LOGGED_IN: 'logged_in',
    LOGGING_IN: 'logging_in',
    FAILED_LOGIN: 'failed_login',
    LOGGED_OUT: 'logged_out',
    LOGGED_IN_AUTHORIZED: 'logged_in_authorized',
    HTTP_UNAUTHORIZED: 'http_unauthorized',
    CENTRE_DATA_LOADED: 'centre.data.loaded',
    CENTRE_DATA_UPDATED: 'centre.data.updated',
    SIGNALR,
};

export default events;
